import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { TICKET_PRODUCT_DATE_DETAIL_QUERY } from "../../../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const { data, loading } = useQuery(TICKET_PRODUCT_DATE_DETAIL_QUERY, {
    variables: { id: match.params.ticketDateId },
  });

  if (loading === true) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  } else if (!loading && data && data.AdminTicketProductDateDetail) {
    const {
      AdminTicketProductDateDetail: { id, commonStatus, ticketDate },
    } = data;
    return (
      <Presenter
        history={history}
        match={match}
        location={location}
        id={id}
        commonStatus={commonStatus}
        ticketedAt={ticketDate}
      />
    );
  }
});
